import { FormName } from './FormName'
import { FormType } from './FormType'
import React, { useContext } from 'react'
import { leadCardContext } from '../../context/LeadCardContext'

export function FormMeta() {
  const { formName, formType, editable, updateFormName, updateFormType } =
    useContext(leadCardContext)
  return (
    <div data-testid="form-meta">
      <FormName editable={editable} formName={formName} onChangeFormName={updateFormName} />
      <FormType editable={editable} formType={formType} onChangeFormType={updateFormType} />
    </div>
  )
}
